<app-page-header
  class="header"
  [backSwipe]="state() === 'main' ? backSwipeConfig : undefined"
  [backButtonRouterLink]="['/main', 'home']"
/>

<div class="top">
  <span class="big">More</span>
  <span class="top__text">All the extras for a perfect visit. Check the game schedule, find gift cards, get apparel, and leave feedback.</span>
</div>

<div class="items" coreActivitySection="Buttons">
  <button
    class="item"
    coreUserActivityClickTracking="OpenBigScreanSchedule"
    (click)="state.set('schedule')"
  >
    BIG SCREEN SCHEDULE
  </button>

  <button
    class="item"
    coreUserActivityClickTracking="OpenGiftCards"
    (click)="state.set('gift-cards')"
  >
    gift cards
  </button>

  <button
    coreUserActivityClickTracking="OpenBillsWatchParty"
    (click)="state.set('party')"
    class="item"
  >
    bills watch party
  </button>

  <button
    class="item"
    coreUserActivityClickTracking="OpenLeaveReview"
    (click)="state.set('review')"
  >
    Leave a review
  </button>

  <button
    coreUserActivityClickTracking="OpenApparelStore"
    (click)="state.set('apparel')"
    class="item with-img"
  >
    <img src="images/pages/apperel.png" width="424" height="70" alt="Apparel" class="item__icon" />
  </button>
</div>

@switch (state()) {
  @case ('schedule') {
    <app-more-schedule
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('gift-cards') {
    <app-more-gift-cards
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('party') {
    <app-more-party
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('review') {
    <app-more-review
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
  @case ('apparel') {
    <app-more-apparel
      @InOutAnimation
      class="full-page"
      (back)="state.set('main')"
    />
  }
}
